<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">個人資料</h1>
      </div>
      <div class="header-right">
      </div>
    </div>
    <div class="layout">
      <div class="page-box">
        <personal-information-form
          ref="form"
          :form="form"
        ></personal-information-form>
        <div>請註意：標有 (*) 的為必填項。</div>
        <el-button type="info" class="submitButton" @click="onSubmit"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUserDetail, putUser } from "@/api/users";
import PersonalInformationForm from "./components/personalInformationForm.vue";
export default {
  components: { PersonalInformationForm },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: null,
        email: null,
        password: null,
        confirmPassword:null,
        phone: null,
        roleId: null,
      },
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          // 提交表单
          this.putUser();
        }
      });
    },
    getUserDetail() {
      getUserDetail(this.$store.getters.adminUserInfo.userId).then((v) => {
        this.form = v.data;
        //字符串深拷贝
        let aaa = v.data.password
        this.form.confirmPassword =  aaa

      });
    },
    putUser() {
      putUser(this.$store.getters.adminUserInfo.userId, this.form).then(() => {
        this.$message.success("修改成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}
.submitButton {
  width: 150px;
  margin-top: 20px;
}
.page-box {
  background-color: #fff;
  padding: 20px;
}
</style>